<template lang="pug">
form(
  name='registrationForm',
  v-on:submit.prevent='registerUser(newUser)'
  novalidate)
  h1.modal__container--title Create an account to get started

  .modal__product--divider

  .ui-input
    p Username
    input(
      type='text',
      name='username',
      v-model='newUser.username',
      placeholder='Choose a username',
      required)

  .ui-input
    p Email
    input(
      type='email',
      name='email',
      v-model='newUser.email',
      placeholder='Your email',
      required)

  .ui-input
    p Password
    input(
      type='password',
      name='password',
      v-model='newUser.password',
      placeholder='Choose a password',
      required)

  .ui-input.marketingConsent--container
    label.checkbox--container
      input(
        type='checkbox',
        name='marketingConsent',
        v-model='newUser.marketing_consent'
      )
      span.checkmark
      p Marketing Consent
    .subtext
      p Flixel can send me product updates and offers via email. You can opt-out at any time.

  .modal__product--divider.divider--bottom

  button.btn.btn--purpleLight(type='submit') Continue

  .options
    .ui-input
      a.link(@click='showLogin()') Already have an account?

</template>

<script>
import eventBus from '../eventBus.js';

export default {
  name: 'buymodalregister',
  data() {
    return {
      newUser: {},
      userAccount: '',
      formData: {},
    };
  },
  props: ['product', 'coupon'],
  methods: {
    showLogin() {
      eventBus.$emit('showLogin');
    },
    registerUser(userInfo) {
      eventBus.$emit('registerUser', userInfo);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/buyModalRegister.vue